export const CONFIG = {
    "env": "test",
    "apiUrlTest":  "/api",
    "apiUrlLive": "/api",
    "company": "tracksol"
}
